module.exports = __webpack_public_path__ + "static/img/main6_10.04b4ebcf.png";